import { IAllDebts, InstallmentInfo } from "../context/PaymentContext";
import { apiLambda } from "./apiLambda";

interface IData {
    name: string;
    cnpj: string;
    pix: InstallmentInfo;
    cupom: string;
    email: string;
    phone: string;
    ipvaSelected: IAllDebts[];
    licenciamentoSelected: IAllDebts[];
    dpvatSelected: IAllDebts[];
    multasSelected: IAllDebts[];
    outrosSelected: IAllDebts[];
    consultCode: number;
    sub: string;
}



export default async function generatePix(
    data: IData,
) {
    try {
        const {
            name,
            cnpj,
            pix,
            cupom,
            email,
            phone,
            ipvaSelected,
            licenciamentoSelected,
            dpvatSelected,
            multasSelected,
            outrosSelected,
            consultCode,
            sub
        } = data;

        const debitos: { codigo: number; valor: number }[] = [];

        if (ipvaSelected.length) {
            ipvaSelected.map((i: IAllDebts) => {
                const debito = {
                    codigo: i.debtsCode,
                    valor: i.value
                };
                debitos.push(debito);
            });
        }

        if (licenciamentoSelected.length) {
            licenciamentoSelected.map((i: IAllDebts) => {
                const debito = {
                    codigo: i.debtsCode,
                    valor: i.value
                };
                debitos.push(debito);
            });
        }

        if (dpvatSelected.length) {
            dpvatSelected.map((i: IAllDebts) => {
                const debito = {
                    codigo: i.debtsCode,
                    valor: i.value
                };
                debitos.push(debito);
            });
        }

        if (multasSelected.length) {
            multasSelected.map((i: IAllDebts) => {
                const debito = {
                    codigo: i.debtsCode,
                    valor: i.value
                };
                debitos.push(debito);
            });
        }

        if (outrosSelected.length) {
            outrosSelected.map((i: IAllDebts) => {
                const debito = {
                    codigo: i.debtsCode,
                    valor: i.value
                };
                debitos.push(debito);
            });
        }

        const body = {
            payloadCaptura: {
                parcelas: pix.month,
                valor: pix.totalPrice,
                cupom: cupom,
                debitos: debitos,
                pix: [
                    {
                        pagador: {
                            nome: name,
                            cpf: cnpj.replace(/\D/g, ''),
                            email: email,
                            telefone: phone.replace(/\D/g, '')
                        },
                        valor: pix.totalPrice
                    }
                ],
                comportamento: {
                    konduto: sub,
                    clearsale: '',
                    analytics: ''
                }
            }
        };

        const payment = await apiLambda.post(`comunix/payment/pix/${consultCode}`, body);

        return payment.data.data;
    } catch (err: any) {
        console.log('GeneratePix ====> ', err.response);
        if (err.response?.data?.warning) {
            return { sucesso: false, warning: err.response.data.warning };
        }
        return { sucesso: false, data: err.response?.data?.data };
    }
}
